module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Regular.cb568b7a.ttf";